import Vue from 'vue';
import Notifications from 'vue-notification';

Vue.use(Notifications, {
  componentName: 'VueNotifications',
});

// eslint-disable-next-line no-underscore-dangle
const _default = {
  ignoreDuplicates: true,
  duration: 3000,
};
const iwalyNotify = {
  success: (payload) => {
    Vue.notify({
      ..._default,
      type: 'success',
      ...payload,
    });
  },
  error: (payload) => {
    Vue.notify({
      ..._default,
      type: 'error',
      ...payload,
    });
  },
};

export { iwalyNotify };
export default iwalyNotify;
